<template>
  <v-card
  flat
  height="100%"
  tile
  id="playlistBulbPickerCard">
    <v-list
    :color="playlistColor"
    height="65"
    dark
    tile>
      <v-list-item :color="playlistColor">
        <v-list-item-avatar>
          <v-btn icon @click="closeSlideout" aria-label="Close add bulbs tab">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Select Bulbs to add to {{ selectedModuleName }}.<v-icon class="ml-2 bulbPickerIcon">mdi-exit-to-app</v-icon></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="addBulbsButton ma-0">
          <v-btn
          v-if="passbackBulbs.length > 0"
          outlined
          dark
          aria-label="Add queued bulbs to playlist"
          @click="handleAddBulbsClicked">
            Add Bulbs
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <iframe
      id="dashIframe"
      frameBorder="0"
      :src="bulbPickerURL"
      width="100%"
      height="92%"
      ref="passbackIframe">
    </iframe>
    <p aria-live="polite" aria-atomic="true" class="aria-feedback">{{ariaLiveText}}</p>
  </v-card>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';
import {
  getServerUrl,
} from '@utilities';
import _ from 'lodash';

export default {
  name: 'PlaylistBulbPicker',
  props: [
    'open',
  ],
  data: () => ({
    ariaLiveText: '',
    baseURL: null,
  }),
  computed: {
    ...mapState([
      'moduleSelected',
      'passbackBulbs',
      'playlist',
      'slideoutData',
      'userToken',
    ]),
    bulbPickerURL() {
      return `${this.baseURL}dash/instructor/My-Bulbs/My-Bulbs?page=1&per_page=20&search=&sort=&section_id=&bulb_id=&interaction_id=&interaction_type=&student_id=&folder_id=&subfolder_id=&lms_class=false&lms_launch=false&lmb_bulb=&lmb_section=&passback_linking=true&embed=true&token=${this.userToken}`;
    },
    playlistColor() {
      return _.get(this.playlist, 'default_color', '#2196F3');
    },
    selectedModuleName() {
      return _.get(this.moduleSelected, 'name', 'Playlist');
    },
  },
  methods: {
    ...mapActions([
      'addBulbsToPlaylist',
    ]),
    ...mapMutations([
      'resetPassbackBulbs',
      'setModuleSelected',
      'setSlideout',
      'setUsedItemsInPlaylist',
    ]),
    closeSlideout() {
      this.setModuleSelected(null);
      this.setUsedItemsInPlaylist();
      this.resetPassbackBulbs();
      this.setSlideout(null);
    },
    handleAddBulbsClicked() {
      this.addBulbsToPlaylist();
    },
  },
  async mounted() {
    this.baseURL = getServerUrl();
  },
  watch: {
    open(newValue, oldValue) {
      if (newValue) {
        const iframe = this.$refs.passbackIframe;
        const iframeDocument = iframe?.contentDocument || iframe?.contentWindow?.document;
        this.$nextTick(() => {
          iframe.contentWindow.focus();
          iframeDocument.getElementById('instructorTableDataRefreshButton').click();
        });
        setTimeout(() => {
          this.ariaLiveText = 'Now entering your Dash to select bulbs to add to module.  Press tab to select bulbs.  When finished exit iFrame and select the Add Bulbs button.';
        }, 700); // JAWS & NVDA will not read aria-live region without this timeout
      }
      if (!newValue && oldValue) {
        this.ariaLiveText = '';
      }
    },
  },
};
</script>

<style scoped>
  .v-list {
    border-radius: 0 !important;
  }
  .addBulbsButton {
    min-width: 120px;
  }
  #playlistBulbPickerCard {
    overflow: hidden;
  }
  .bulbPickerIcon {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  .aria-feedback {
    text-indent: -10000px;
    font-size: 0.1px;
  }
  button:focus {
    outline: solid 2px #FD9727 !important;
  }
</style>
